import React, { useState, useEffect } from "react";
import "../all css/countsection.css";
import CountUp from "react-countup";
const count_img = require("../../assets/happpy_client.png");
const count_img1 = require("../../assets/student_counselling.png");
const count_img2 = require("../../assets/univercities.png");
const count_img3 = require("../../assets/courses.png");

function CountingSection(props) {
  const [allCountItem, setAllCountItem] = useState([
    {
      countImg: count_img,
      countingText: 20,
      countingTitle: "Countries",
    },
    {
      countImg: count_img1,
      countingText: 64000,
      countingTitle: "Student's Counselled",
    },
    {
      countImg: count_img2,
      countingText: 3300,
      countingTitle: "Institutions",
    },
    {
      countImg: count_img3,
      countingText: 84000,
      countingTitle: "Courses",
    },
  ]);

  // const counterNum = document.querySelector(".counting_number_text");
  // const speed = 200;
  // counterNum.forEach((curElem) => {
  //     const updateNumber = () =>{
  //         const targetNumber = parseInt(curElem.dataset.number);
  //         // console.log(targetNumber);
  //         const initialNum =     parseInt(curElem.innerText);
  //         // console.log(initialNum);

  //         const incrementNumber = Math.trunc(targetNumber / speed);
  //         // console.log(incrementNumber);
  //         if (initialNum < targetNumber){
  //             curElem.innerText = `${initialNum + incrementNumber}+`;
  //             setTimeout(updateNumber, 10);
  //         }
  //     };
  //     updateNumber();
  // }

  // useEffect(() => {

  // },[])

  return (
    <section className="counting_section_main_container">
      <div className="counting_section_under_main_container">
        <div className="counting_section_flex_container">
          {allCountItem.map((perCountItem) => {
            return (
              <div className="each_count_section_container" key={Math.random()}>
                <div className="count_img_section_container">
                  <img
                    className="count_img"
                    src={perCountItem.countImg}
                    alt="count_img"
                  />
                </div>
                <CountUp
                  className="counting_number_text"
                  duration={8}
                  delay={0}
                  end={perCountItem.countingText}
                  suffix="+"
                  enableScrollSpy={true}
                />

                {/* <h6 className="counting_number_text">
                  {perCountItem.countingText}
                </h6> */}
                <p className="counting_title_text">
                  {perCountItem.countingTitle}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default CountingSection;
